var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewOscar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C6.7 0 4 2.7 4 6s6 11 6 11 6-7.7 6-11-2.7-6-6-6m0 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 11.1c-.3.6-.6 1.2-1 1.8 1.7.6 2.7 1.4 2.7 2.1 0 1.2-3.2 3-8 3s-8-1.8-8-3c0-.7 1-1.5 2.7-2.2-.4-.6-.7-1.2-1-1.8C1.4 12 0 13.4 0 15c0 2.8 4.2 5 9.8 5 5 0 10.2-1.7 10.2-5 0-1.6-1.4-3-3.7-3.9",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewOscar);
export default __webpack_public_path__ + "static/media/new-oscar.748279bfbc18933e8984c90ff10ff6a2.svg";
export { ForwardRef as ReactComponent };